import React from "react";
import StatusTable from "./StatusTable";
import openStatus from "../../../src/assets/images/open-sign.png"
import pendingStatus from "../../../src/assets/images/pulse.png"
import closedStatus from "../../../src/assets/images/closed-sign.png"
import "./StatusTable.css";

export default function AlertsStatusTable() {
  const [alertStatusState, setAlertStatusState] = React.useState({
    columns: [
      { title: "Κωδικός", field: "alertStatusId", type: "numeric" },
      { title: "Περιγραφή", field: "alertStatusStatus" },
      { title: "Εικονίδιο", field: "alertStatusIcon" },
    ],
    data: [
      {
        alertStatusId: 1,
        alertStatusStatus: "Ανοιχτή",
        alertStatusIcon: (
          <img
            src={openStatus}
            alt="open"
          />
        ),
      },
      {
        alertStatusId: 2,
        alertStatusStatus: "Σε Εξέλιξη",
        alertStatusIcon: (
          <img
            src={pendingStatus}
            alt="pending"
          />
        ),
      },
      {
        alertStatusId: 3,
        alertStatusStatus: "Κλειστή",
        alertStatusIcon: (
          <img
            src={closedStatus}
            alt="closed"
          />
        ),
      },
    ],
  });

  return (
    <StatusTable
      title="Καταστάσεις ειδοποιήσεων"
      columns={alertStatusState.columns}
      data={alertStatusState.data}
    />
  );
}
